<div class="alert-dialog-container" [ngStyle]="getDialogContainerStyle()">
  <div class="d-grid gap-3">
    <div class="d-flex justify-content-center">
      <img
        class="thumb"
        src="../../../assets/animations/party.gif"
        alt="Success"
      />
    </div>
    <div class="alert-titte">
      Thank you for completing the parental <br />consent form.
    </div>

    <div class="alert-dialog-subcontent mt-4">
      If portal consent was provided, your child will receive login details
      shortly. If not, they can still <br />attend events — we will not retain
      their personal information.
    </div>

    <div class="alert-dialog-subcontent">
      If media consent was approved, your child may be photographed or filmed at
      events. If declined,<br />
      they will not be photographed or identified.
    </div>
    <div class="alert-dialog-subcontent">
      For any questions, email
      <strong>{{ "constructionpathways@csq.org.au." }}</strong>
    </div>
  </div>

  <mat-dialog-actions class="alert-dialog-actions">
    <button
      class="cancel-button"
      (click)="onCancelClick()"
      [ngStyle]="getCancelButtonStyle()"
    >
      Close
    </button>
  </mat-dialog-actions>
</div>
